import { render } from "./daka_setting.vue?vue&type=template&id=0ec56d6b&scoped=true"
import script from "./daka_setting.vue?vue&type=script&lang=js"
export * from "./daka_setting.vue?vue&type=script&lang=js"

import "./daka_setting.vue?vue&type=style&index=0&id=0ec56d6b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec56d6b"]])

export default __exports__